<template>
	<div>
		<div class="giftDetails">
			<navBar>{{ title }}</navBar>
			<div class="content-box">
				<div class="tupian"><img :src="dataObj.shopimages" alt="" style="width: 100%;" /></div>
				<div class="title font30 df-a">{{ dataObj.name }}</div>
				<div class="contentText font26">
					<p>礼品简介</p>
					<p>{{ dataObj.shopitem }}</p>
					<p v-html="dataObj.content"></p>
				</div>
			</div>
			<div class="footer df-a df-sb">
				<div class="font34 mCc">{{ dataObj.gold }}芯币</div>
				<div class="bnt df-mc mCf font34" @click="changeQue">确认</div>
			</div>
		</div>
		<div class="xuancuangguan df-a dunhuanliping" v-if="isxuan">
			<div class="conetn" v-if="address.length == 0">
				<!-- <van-icon name="cross" size="22" style="position: absolute; right: 0.5rem; top: 0.35rem" /> -->
				<div class="title tac font32">提示</div>
				<div class="text font26 tac">
					你还没有填写收货地址
					<br />
					是否去填写收货地址?
				</div>
				<div class="bntBox font32 mCc df-sb">
					<div class="bnt df-mc" @click="isxuan = false">取消</div>
					<div class="bnt df-mc" @click="goPage">确定</div>
				</div>
			</div>
			<div class="duihuanconetn" v-else>
				<div class="font30 title tac">兑换礼品确认</div>
				<div class="font28">你选择的礼品是【{{ dataObj.name }}】，请确认信息:</div>
				<div class="text font26">
					所需芯币 {{ dataObj.gold }}芯币
					<br />
					<!-- 经验等级 未到 50级，不可兑换 -->
					<!-- 	<br />
					剩余次数 还可兑换1个礼品
					<br /> -->
					发货时间 {{tomorrow}}
					<br />
					更换礼品 礼品发货前可随时更换
				</div>
				<div class="font22 mCc">请核对上述信息，确认无误后进行兑换</div>
				<div class="duihuanBut df-sb font34">
					<div class="bnt df-mc" @click="isxuan = false">稍后决定</div>
					<div class="bnt df-mc mCf" @click="exchangeshop">立即兑换</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'textBook',
	watch: {},
	data() {
		return {
			title: this.$route.query.title || '礼品详情',
			isxuan: false,
			dataObj: this.$store.getters['common/getLianxiData1'] || {},
			address: [],
			tomorrow:''
		};
	},
	created() {
		this.getaddress();
		let today = new Date();
		today.setTime(today.getTime() + 24 * 60 * 60 * 1000);
		var tomorrow = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
		this.tomorrow = tomorrow
	},
	methods: {
		getaddress() {
			this.$api.getaddress().then((res) => {
				let resData = res.data?.data;
				this.address = resData;
			});
		},

		exchangeshop() {
			let apiData = {};
			if (this.address.length > 0) {
				for (let i = 0; i < this.address.length; i++) {
					if (this.address[i].isdefault == 1) {
						for (let key in this.address[i]) {
							apiData[key] = this.address[i][key];
						}
					}
				}
			}
			apiData.shopid = this.dataObj.id;
			this.$api.exchangeshop(apiData).then((res) => {
				if (res.code == 1) {
					this.$toast({ message: res.msg, icon: 'success', size: '2.9rem' });
					this.isxuan = false;
				} else {
					this.$toast({ message: res.msg, icon: 'warning-o', size: '2.9rem' });
				}
			});
		},
		goPage() {
			this.$router.push({
				path: '/giftAddress',
				query: {
					id: 45,
					name: 'name',
					active: 1
				}
			});
		},
		changeQue() {
			this.isxuan = true;
		}
	}
};
</script>
<style>
.van-toast {
	min-width: 2.8rem; /* 或者你想要的任何宽度 */
}
</style>
<style lang="scss" scoped>
.giftDetails {
	

	.content-box {
		padding-bottom: 0.2rem;
		height: calc(100% - 2.06rem);
		position: fixed;
		left: 0;
		right: 0;
		top: 1.08rem;
		overflow: auto;
		background: #f5faff;
		.tupian {
			width: 100%;
			min-height: 5.66rem;
			background-color: #909090;
		}
		.title {
			width: 100%;
			height: 0.98rem;
			padding-left: 0.28rem;
			background-color: #fff;
		}
		.contentText {
			margin-top: 0.24rem;
			width: 100%;
			min-height: 4rem;
			background-color: #fff;
			padding: 0.4rem 0.3rem;
			::v-deep img{
				height: 100%;
			}
		}
	}
	.footer {
		width: 100%;
		height: 0.98rem;
		background: #fff;
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		padding: 0 0.32rem;
		.bnt {
			width: 3.26rem;
			height: 0.88rem;
			background: #ff7a32;
			border-radius: 0.44rem;
		}
	}
}
.xuancuangguan {
	width: 100%;
	height: 100vh;
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	z-index: 33;
	padding: 0 1.35rem;
	background-color: rgba(0, 0, 0, 0.5);
	&.dunhuanliping {
		padding: 0 0.85rem;
	}
	.conetn {
		width: 100%;
		// height: 2.56rem;
		background: #ffffff;
		border-radius: 0.1rem;
		position: relative;
		padding-top: 0.3rem;
		.text {
			padding: 0.2rem 0 0.3rem 0;
		}
		.bntBox {
			height: 0.8rem;
			border-top: 1px solid #dcdcdc;
			.bnt {
				width: 50%;
				height: 0.8rem;
				&:last-child {
					border-left: 1px solid #dcdcdc;
				}
			}
		}
	}
	.duihuanconetn {
		width: 100%;
		// height: 2.56rem;
		background: #ffffff;
		border-radius: 0.3rem;
		padding: 0.4rem 0.28rem 0.5rem;
		.title {
			padding-bottom: 0.35rem;
		}
		.text {
			width: 100%;
			padding: 0.1rem 0.34rem;
			background: #f8f8f8;
			border-radius: 0.1rem;
			margin-top: 0.28rem;
			margin-bottom: 0.34rem;
			line-height: 0.56rem;
		}
		.duihuanBut {
			margin-top: 0.2rem;
			.bnt {
				width: calc(50% - 0.28rem);
				height: 0.88rem;
				border-radius: 0.1rem;
				&:first-child {
					background: #f8f8f8;
				}
				&:last-child {
					background: #ff7a32;
				}
			}
		}
	}
}
</style>
